"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginMethodByUserId = void 0;
const loginMethodsWithPrefixes = [
    { method: 'Google', prefix: 'google' },
    { method: 'Apple', prefix: 'apple' },
    { method: 'Facebook', prefix: 'facebook' },
];
const getLoginMethodByUserId = (userId) => {
    var _a;
    const unprefixedUserId = userId.replace(/^oidc\|/, '');
    const usedMethod = loginMethodsWithPrefixes.find(({ prefix }) => unprefixedUserId.startsWith(prefix));
    return (_a = usedMethod === null || usedMethod === void 0 ? void 0 : usedMethod.method) !== null && _a !== void 0 ? _a : 'Manual';
};
exports.getLoginMethodByUserId = getLoginMethodByUserId;
//# sourceMappingURL=user-id.js.map